/** @format */

import { defaultActions } from '../../../core/actionsDefault';

export const clientAddressesConstants = {
    CLIENT_ADDRESS_LIST: 'client_address_list',
    CLIENT_ADDRESS_EDIT: 'client_address_edit',
    CLIENT_ADDRESS_ITEM: 'client_address_item',
    CLIENT_ADDRESS_DELETE: 'client_address_delete',
    CLIENT_ADDRESS_UPDATE: 'client_address_update',
    CLIENT_ADDRESS_ADD: 'client_address_add',
    CLIENT_ADDRESS_CHECK: 'client_address_check',
    CLIENT_ADDRESS_STREET_CHECK: 'client_address_street_check',
    CLIENT_ADDRESS_CITY_CHECK: 'client_address_city_check',
    CLIENT_ADDRESS_BOROUGH_CHECK: 'client_address_borough_check',
    CLIENT_ADDRESS_DISTRICT_CHECK: 'client_address_district_check',
    CLIENT_ADDRESS_STATE_CHECK: 'client_address_state_check',
};

export class clientAddressesActions extends defaultActions {}
